<template>
  <div class="timeslot-collection">
    <draggable
      :class="{
        'timeslot-collection__dropzone': related_commitments.length === 0
      }"
      v-model="draggablesList"
      group="commitment-shared"
      draggable=".commitment-draggable">

      <!-- INCLUDE: DragListCommiements -->
      <div
        v-for="commitment in draggablesList"
        :key="commitment.$id"
        class="commitment-draggable mb-1 p-1">
        <!-- <pre class="mini-pre">{{commitment.$id}}</pre> -->
        <InlineCommitment
          :goal-id="commitment.goalId"
          :commitment-id="commitment.$id"
          :active="commitment.active"
          :selected="get_effort_selected === commitment.$id"
          @select="SET_ACTIVE_EFFORT" />
      </div>

      <!-- <pre class="mini-pre">{{draggablesList}}</pre> -->
      <!-- <pre class="mini-pre">{{related_commitments}}</pre> -->

    </draggable>

    <div v-show="related_commitments.length === 0" class="timeslot-collection__unassigned">
      <i class="el-icon-error" style="color: #c0c4cc"></i> No commitment assigned.
    </div>
    <!-- TODO: button to add one -->

    <el-button size="small" type="text" @click="onAddCommitment" class="py-1 mt-1 mx-auto d-block">
      <font-awesome-icon icon="plus" /> Add commitment
    </el-button>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import InlineCommitment from '@/components/Inline/InlineCommitmentWithProgress';
import DraggablesMixin from './DraggablesMixin'
import Draggable from 'vuedraggable';
import GoalPromptMixin from "@/components/Mixins/Prompts/GoalPrompt"

export default {
  mixins: [ DraggablesMixin, GoalPromptMixin ],
  props: {
    timeslot_collection_id: { required: true },
    timeslot_collection: {
      type: Object,
      default: () => {return null}
    },
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('calendar',[
      "get_effort_selected"
    ]),
  },
  methods: {
    ...mapMutations('calendar', [
      'SET_ACTIVE_EFFORT'
    ]),

    onAddCommitment() {
      this.$goal_prompt({ title: 'Please select a goal' })
      .then(({ done, targetGoalId }) => {
        console.log("onAddCommitment", this.timeslot_collection_id, targetGoalId);

        this.$root.showNewModal('effort', {
          type: 'TASKLIST',
          goalId: targetGoalId,
          tscId: this.timeslot_collection_id,
        });
        done();
      })
    },
  },
  components: {
    InlineCommitment,
    Draggable,
  }
}
</script>

<style>
.timslot-collection {
  margin: 0 0.5em;
}
.commitment-draggable {
  padding: 1px;
  border: 1px solid #dadada;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 #0000000d;
  background-color: white;
  margin-bottom: 0.25em;
  flex: 0 0 310px;
}
.commitment-draggable.sortable-ghost {
  min-height: 10px;
  border: 1px dashed #909399 !important;
  border-radius: 3px;
  padding: 0;
}
.commitment-draggable.sortable-ghost > * {
  visibility: hidden !important;
}
.timeslot-collection__dropzone {
  border: 2px dashed #c0c4cc;
  min-height: 30px;
  margin: 0.25em 0;
  padding: 0.25em;
}
.timeslot-collection__dropzone:not(:empty) + .timeslot-collection__unassigned {
  /* hide text on drag over */
  display: none;
}
.timeslot-collection__unassigned {
  pointer-events: none;
  color: #c0c4cc;
  margin-top: -33px;
  margin-left: 0.5em;
  height: 30px;
  line-height: 30px;
}
</style>
